import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../LoadingSlice";
import { toast } from "react-toastify";

interface StructuralExcelState {
  StructuralExcel: {
    load: boolean;
    data: [];
  };
}

export const StructuralExcelSlice = createSlice({
  name: "StructuralExcel",
  initialState: {
    StructuralExcel: {
      load: false,
      data: [],
    },
  } as StructuralExcelState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(postStructuralExcel.pending, (state: StructuralExcelState) => {
        state.StructuralExcel.load = true;
      })
      .addCase(postStructuralExcel.fulfilled, (state: StructuralExcelState, action: any) => {
        state.StructuralExcel.data = action.payload;
        state.StructuralExcel.load = false;
      })
      .addCase(postStructuralExcel.rejected, (state: StructuralExcelState) => {
        state.StructuralExcel.load = false;
      })
      .addCase(fetchStructuralExcel.pending, (state: StructuralExcelState) => {
        state.StructuralExcel.load = true;
      })
      .addCase(fetchStructuralExcel.fulfilled, (state: StructuralExcelState, action: any) => {
        state.StructuralExcel.data = action.payload;
        state.StructuralExcel.load = false;
      })
      .addCase(fetchStructuralExcel.rejected, (state: StructuralExcelState) => {
        state.StructuralExcel.load = false;
      });
  },
});

export default StructuralExcelSlice.reducer;

export const postStructuralExcel = createAsyncThunk(
  "StructuralExcel/postStructuralExcel",
  async (param: { apiParam: { project_pin: any, layout_id: any, excel: any, fetchStructularExcel: any }, navigation: any }, thunkAPI) => {
    try {
      thunkAPI.dispatch(toggleLoading());

      const { data } = await DataServer.post("api/postStrcturalAnalysisExcel", {
        project_pin: param.apiParam.project_pin,
        layout_id: param.apiParam.layout_id,
        upload_structural_analysis: param.apiParam.excel
      });

      thunkAPI.dispatch(toggleLoading());

      toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});

      const handleonConfirm = () => {
        param.apiParam.fetchStructularExcel();
      };

      thunkAPI.dispatch(toggleLoading());

      return data.data;
    } catch (error) {
      thunkAPI.dispatch(toggleLoading());
      toast.error("Something went wrong!",{theme: "colored"});
    }
  }
);

export const fetchStructuralExcel = createAsyncThunk(
  "StructuralExcel/fetchStructuralExcel",
  async (param: { apiParam: { project_pin: any, layout_id: any } }, thunkAPI) => {
    try {
      thunkAPI.dispatch(toggleLoading());
      const { data } = await DataServer.post("api/getStrcturalAnalysisExcelData", {
        project_pin: param.apiParam.project_pin,
        layout_id: param.apiParam.layout_id
      });
      thunkAPI.dispatch(toggleLoading());
      return data.data;
    } catch (error) {
      thunkAPI.dispatch(toggleLoading());
    }
  }
);
